import { render, staticRenderFns } from "./TabAsignarCorreduria.vue?vue&type=template&id=2580457e"
import script from "./TabAsignarCorreduria.vue?vue&type=script&lang=js"
export * from "./TabAsignarCorreduria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2580457e')) {
      api.createRecord('2580457e', component.options)
    } else {
      api.reload('2580457e', component.options)
    }
    module.hot.accept("./TabAsignarCorreduria.vue?vue&type=template&id=2580457e", function () {
      api.rerender('2580457e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/formalizacionactas/TabAsignarCorreduria.vue"
export default component.exports